export const SELECTED_TEAM_NAME_LIST_REQUEST = 'SELECTED_TEAM_NAME_LIST_REQUEST';
export const SELECTED_TEAM_NAME_LIST_SUCCESS = 'SELECTED_TEAM_NAME_LIST_SUCCESS';
export const SELECTED_TEAM_NAME_LIST_ERROR = 'SELECTED_TEAM_NAME_LIST_ERROR';

export const ADD_COACH_BULK_REQUEST = 'ADD_COACH_BULK_REQUEST';
export const ADD_COACH_BULK_SUCCESS = 'ADD_COACH_BULK_SUCCESS';
export const ADD_COACH_BULK_ERROR = 'ADD_COACH_BULK_ERROR';